import api from '../../services/api.ts';
import i18n from '../../utils/i18n.ts';
import { toast } from 'react-toastify';

export const fetchSearchRegulations = async ({
  search,
  topic,
  unit,
  type = [] as string[] | null,
}: {
  search?: string | null;
  topic?: string | null;
  unit?: string | string[] | null;
  type?: string | string[] | null;
}) => {
  const params = new URLSearchParams();
  if (search) params.append('searchTerm', search);
  if (topic) params.append('topicId', topic);
  if (unit) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    unit?.forEach((un: string[]) => params.append('unitInChargeIds', un.toString()));
  }
  if (type) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    type?.forEach((tp: string[]) => params.append('types', tp.toString()));
  }
  const response = await api.get(`/regulations/search?${params.toString()}`);

  if (!response) {
    toast.error(i18n.t('error.api.get-search-results'));
  }

  return response.data;
};

export const fetchEmail = async () => {
  const response = await api.get(`/info/contact-email`);

  if (!response) {
    toast.error('Error');
  }

  return response.data || 'arbeitsgrundlagen@goethe.de';
};

export const fetchNewestRegulations = async ({
  pageSize,
  newestPage,
}: {
  pageSize: number;
  newestPage: number;
}) => {
  const response = await api.get(
    `/newestRegulations?pageSize=${pageSize}&pageNumber=${newestPage}&showInActive=false`,
  );

  if (!response) {
    toast.error(i18n.t('error.api.get-newest-regulations'));
  }

  return response.data;
};

export const fetchUpdatedRegulations = async ({
  pageSize,
  updatedPage,
}: {
  pageSize: number;
  updatedPage: number;
}) => {
  const response = await api.get(
    `/lastUpdatedRegulations?pageSize=${pageSize}&pageNumber=${updatedPage}&showInActive=false`,
  );

  if (!response) {
    toast.error(i18n.t('error.api.get-last-updated-regulations'));
  }

  return response.data;
};

export const fetchMostViewedRegulations = async ({
  pageSize,
  mostViewedPage,
}: {
  pageSize: number;
  mostViewedPage: number;
}) => {
  const response = await api.get(
    `/mostViewedRegulations?pageSize=${pageSize}&pageNumber=${mostViewedPage}&showInActive=false`,
  );

  if (!response) {
    toast.error(i18n.t('error.api.get-last-most-viewed-regulations'));
  }

  return response.data;
};

export const fetchSentRequests = async () => {
  const response = await api.get(`/sentRequests`);

  if (!response) {
    toast.error(i18n.t('error.api.get-sent-requests'));
  }

  return response.data;
};
export const fetchPublicationRequests = async () => {
  const response = await api.get(`/publicationRequests`);

  if (!response) {
    toast.error(i18n.t('error.api.get-publication-requests'));
  }

  return response.data;
};
export const fetchDeleteRequests = async () => {
  const response = await api.get(`/deleteRequests`);

  if (!response) {
    toast.error(i18n.t('error.api.get-deletion-requests'));
  }

  return response.data;
};